// import PlansService from "./plans.service";
import Phones from "google-libphonenumber";
import Storage from "./storage.service";
import Settings from "./settings";
import Helpers from "./helpers";

import Countries from "./countries";

var Forms = {};

Forms.phoneUtil = Phones.PhoneNumberUtil.getInstance();

Forms.initForm = (namespace, fields, submit) => {
  Forms[namespace] = {};
  Forms[namespace]["id"] = namespace;
  Forms[namespace]["submit"] = submit;
  Forms[namespace]["reset"] = () => {
    Forms.reset(namespace);
  };

  let field_ids = Object.keys(fields);

  Forms[namespace]["fields_validity"] = {};
  Forms[namespace]["validity"] = false;
  Forms[namespace]["fields"] = field_ids;
  Forms[namespace]["focused"] = "";

  Forms[namespace]["loading"] = false;

  for (let field_id of field_ids) {
    Forms[namespace][field_id] = { ...fields[field_id] };
    Forms[namespace][field_id]["validity_checked"] = false;

    Forms[namespace]["fields_validity"][field_id] = true;
  }
  Storage.set("form_" + namespace, Forms[namespace]);
};

// Forms.loadOrInitForm = (storage_id, namespace, fields, submit) => {
// 	if(Forms[namespace]){
// 		Storage.set("form_" + namespace, Forms[namespace]);
// 	} else {
// 		let saved_form = Storage.get(storage_id, true);
// 		if(saved_form){
// 			try {
// 				let form_parsed = JSON.parse(saved_form);
// 				Forms[namespace] = form_parsed;
// 				// Forms[namespace]["from_storage"] = true;
// 				Storage.set("form_" + namespace, Forms[namespace]);
// 			} catch (err) {
// 				Forms.initForm(namespace, fields, submit);
// 			}

// 		} else {
// 			Forms.initForm(namespace, fields, submit);
// 		}
// 	}

// };

Forms.focusNext = (namespace, id) => {
  let next = Forms[namespace][id]["next_focus"];
  if (next) {
    Forms[namespace]["focused"] = next;
  } else {
    Forms[namespace]["focused"] = "";
  }
  Storage.set("form_" + namespace, Forms[namespace]);

  setTimeout(() => {
    Forms[namespace]["focused"] = "";
    Storage.set("form_" + namespace, Forms[namespace]);
  }, 1000);
};

Forms.isCardExpiryDateValid = (item) => {
  let monthYear = Helpers.getMonthYear(item);

  let getDate = new Date();
  let current_year = getDate.getFullYear();
  let current_month = getDate.getMonth() + 1;

  return (
    monthYear.month >= 1 &&
    monthYear.month < 13 &&
    monthYear.year <= current_year + 10 &&
    (monthYear.year > current_year ||
      (monthYear.year === current_year && monthYear.month >= current_month))
  );
};

Forms.reset = (namespace) => {
  Forms[namespace]["loading"] = false;
  Storage.set("form_" + namespace, Forms[namespace]);
};

Forms.submit = (namespace) => {
  Forms[namespace]["loading"] = true;
  Storage.set("form_" + namespace, Forms[namespace]);
  Forms[namespace]["submit"](Forms[namespace]);
};

Forms.inputChangedHandler = (namespace, event, id) => {
  let val = Forms.getEventValue(event);

  let type = Forms[namespace][id]["type"];
  let checkValidity = true;

  if (type === "phone" || type === "phone_short") {
    if (type === "phone_short") {
      val = "05" + val;
    }
    val = val.replace(/-/g, "").replace(/x/g, "").replace(/ /g, "");
    if (!Settings.formats.digits_with_plus.test(val)) {
      return;
    }
    if (!Settings.formats.phonemax.test(val)) {
      return;
    }
  }

  if (type === "cvv") {
    let dependency = Forms[namespace][id]["dependency"];
    let dependency_field = Forms[namespace][dependency];
    let is_amex = false;
    if (dependency_field) {
      is_amex =
        dependency_field["result"] && dependency_field["result"]["is_amex"];
    }

    let tester = Settings.formats.cardcvvInitial;

    if (is_amex) {
      tester = Settings.formats.cardcvvInitialAmex;
    }

    if (!tester.test(val)) {
      return;
    }
  }

  if (type === "emirates_id") {
    val = val.replace(/-/g, "").replace(/x/g, "").replace(/ /g, "");

    if (!Settings.formats.digits_only.test(val)) {
      return;
    }
  }

  if (type === "card_expiry_date") {
    let dateSplitted = val.split('/');
    if (dateSplitted?.[1]?.length === 4){
      let yy = dateSplitted[1].substr(2);
      val = `${dateSplitted[0]}/${yy}`
    }
    if (
      val.indexOf("/") === 0 ||
      val.split("/").length - 1 > 1 ||
      val.length > 5
    ) {
      return;
    }
    if (
      Forms[namespace][id]["value"].length === 1 &&
      val.length === 2 &&
      val.substr(1, 1) !== "/"
    ) {
      val = val + "/";
    }

    if (
      Forms[namespace][id]["value"].length === 2 &&
      val.length === 3 &&
      val.substr(2, 1) !== "/"
    ) {
      val = val.substr(0, 2) + "/";
    }

    if (!Settings.formats.digits_slashes.test(val)) {
      return;
    }
  }
  if (type === "card_holder_name") {
    if (!Settings.formats.card_text_only.test(val)) {
      return;
    }
  }
  if (val !== Forms[namespace][id]["value"]) {
    if (type === "card") {
      let without_x = val.replace(/x/g, "");
      without_x = without_x.replace(/ /g, "");
      let amex_pattern = Settings.formats.cards.amex;
      let is_amex = amex_pattern.test(without_x);

      Forms[namespace][id]["result"] = { is_amex: is_amex };

      if (is_amex) {
        checkValidity = Settings.formats.limits.card_amex_max.test(without_x);
      } else {
        checkValidity =
          Settings.formats.limits.card_general_max.test(without_x);
      }
    }

    if (type === "cvv") {
      checkValidity = Settings.formats.limits.cvv_max.test(val);
    }

    if (type === "card_expiry_date") {
      checkValidity = Settings.formats.limits.card_date_max.test(val);
    }

    if (type === "phone_short") {
      checkValidity = val.length === 10;
    }

    if (type === "emirates_id") {
      checkValidity = Settings.formats.emirates_id.test(val);
    }

    if (!checkValidity) {
      if (type === "phone_short" || type === "card") {
        let without_x = val.replace(/x/g, "");
        without_x = without_x.replace(/ /g, "");

        let old_without_x = Forms[namespace][id]["value"].replace(/x/g, "");
        old_without_x = old_without_x.replace(/ /g, "");

        if (without_x.length < old_without_x.length) {
          checkValidity = true;
        }
      }
    }

    Forms[namespace][id]["value"] = val;
    Forms[namespace][id]["validity_checked"] = false;
    Storage.set("form_" + namespace, Forms[namespace]);

    if (checkValidity) {
      setTimeout(() => {
        Forms.checkFieldValidity(namespace, id);
      }, 100);
    }
  }
};

Forms.checkFormValidity = (namespace) => {
  let valid = true;
  let fields = Forms[namespace]["fields"];

  if (fields) {
    for (let field of fields) {
      if (
        (Forms[namespace][field]["required"] &&
          !Forms[namespace][field]["value"]) ||
        !Forms[namespace]["fields_validity"][field]
      ) {
        valid = false;
        break;
      }
    }
  }

  Forms[namespace]["validity"] = valid;
  Storage.set("form_" + namespace, Forms[namespace]);
};

Forms.checkFieldValidity = (namespace, id, e=null) => {
  if (id) {
    let fields_validity = Forms[namespace]["fields_validity"];
    let value = Forms[namespace][id]["value"];
    let type = Forms[namespace][id]["type"];
    if (Forms[namespace][id]["required"] && !Forms[namespace][id]["value"]) {
      fields_validity[id] = false;
    } else {
      fields_validity[id] = true;
      if (type === "phone" || type === "phone_short") {
        if(e && e.type === 'blur'){
          Forms.checkPhoneNumberValidity(namespace, id);
          // let dependency_id = Forms[namespace][id]["dependency"];
          // let dependency = Forms[namespace][dependency_id]["value"];
          // let country = Countries.Countries[dependency];
          // if (country && country.ISO_2Code) {
          //   let number = Forms.phoneUtil.parse(value, country.ISO_2Code);
          //   fields_validity[id] = Forms.phoneUtil.isValidNumberForRegion(number, country.ISO_2Code);
          // } else {
          //   fields_validity[id] = Settings.formats.phonenumber.test(value);
          // }
        } else {
          if (value.length > 9 && Settings.formats.phonenumber.test(value)) {
            Forms.checkPhoneNumberValidity(namespace, id);
            // let dependency_id = Forms[namespace][id]["dependency"];
            // let dependency = Forms[namespace][dependency_id]["value"];
            // let country = Countries.Countries[dependency];
            // if (country && country.ISO_2Code) {
            //   let number = Forms.phoneUtil.parse(value, country.ISO_2Code);
            //   fields_validity[id] = Forms.phoneUtil.isValidNumberForRegion(number, country.ISO_2Code);
            // } else {
            //   fields_validity[id] = Settings.formats.phonenumber.test(value);
            // }
          } 
          // else {
          //   fields_validity[id] = false;
          // }
        }
        }

      if (type === "country" && Forms[namespace][id]["dependent"]) {
        Forms.checkFieldValidity(namespace, Forms[namespace][id]["dependent"]);
        return;
      }

      if (type === "card") {
        let is_unrecognized_card = false;

        let amex_pattern = Settings.formats.cards.amex;
        let general_pattern = Settings.formats.cardnumber;

        let without_x = value.replace(/x/g, "");
        without_x = without_x.replace(/ /g, "");

        let luhn_valid = Helpers.luhn(without_x);

        let test = false;

        let is_amex = amex_pattern.test(without_x);

        if (is_amex) {
          let amex_length = Settings.formats.limits.card_amex_max;
          test = amex_length.test(without_x);
        } else {
          if (luhn_valid) {
            test = general_pattern.test(without_x);
          }
        }

        let card_type = "";

        //@temp solution for unsupported cards

        if (luhn_valid) {
          card_type = Helpers.getCardType(without_x);
          if (!card_type || !card_type.code) {
            is_unrecognized_card = true;
            test = false;
          }
        }

        fields_validity[id] = test;

        Forms[namespace][id]["result"] = {
          is_amex: is_amex,
          luhn: luhn_valid,
          is_unrecognized_card: is_unrecognized_card,
          card_type: card_type.type,
        };
      }

      if (type === "promo_code") {
        let promoCodeLength = value.length;
        let max = Storage.get("businessConfig").max_promo_code_length;
        let min = Storage.get("businessConfig").min_promo_code_length;
        fields_validity[id] = !(promoCodeLength > max || promoCodeLength < min);
      }

      if (type === "emirates_id") {
        let without_x = value.replace(/x/g, "");
        without_x = without_x.replace(/ /g, "");
        fields_validity[id] = Settings.formats.emirates_id.test(without_x);
      }

      if (type === "cvv") {
        let without_x = value.replace(/x/g, "");
        without_x = without_x.replace(/ /g, "");

        let test = Settings.formats.cardcvv.test(without_x);
        let dep = Forms[namespace][id]["dependency"];
        if (dep) {
          let dep_result = Forms[namespace][dep]["result"];
          if (dep_result && dep_result["is_amex"]) {
            test = Settings.formats.cardcvv4.test(without_x);
          }
        }
        fields_validity[id] = test;
      }

      if (type === "card_expiry_date") {
        let test = Settings.formats.expiry.test(value);
        if (test) {
          test = Forms.isCardExpiryDateValid(value);
        }
        fields_validity[id] = test;
      }

      if (type === "emirates_id") {
        let test = Settings.formats.emirates_id.test(value);
        fields_validity[id] = test;
      }

      if (type === "card_holder_name") {
        let test = Settings.formats.text_only.test(value);
        fields_validity[id] = test;
      }
    }

    Forms[namespace]["fields_validity"] = fields_validity;
    Forms[namespace][id]["validity_checked"] = true;

    if (!fields_validity[id]) {
      Forms[namespace]["validity"] = false;
      Storage.set("form_" + namespace, Forms[namespace]);
      return;
    } else {
      Storage.set("form_" + namespace, Forms[namespace]);

      Forms.focusNext(namespace, id);

      Forms.checkFormValidity(namespace);
    }
  }
};

Forms.getEventValue = (event, id) => {
  if (event && event.target) {
    if (event.target.type === "checkbox") {
      return event.target.checked;
    } else {
      return event.target.value;
      // if(id==="address_phone"){
      // 	new_state[id] = event.target.value.replace(/-/g,'').replace(/x/g,'');
      // }
    }
  } else {
    return event;
  }
};

Forms.checkPhoneNumberValidity = (namespace, id) => {
  let fields_validity = Forms[namespace]["fields_validity"];
  let value = Forms[namespace][id]["value"];
  let dependency_id = Forms[namespace][id]["dependency"];
  let dependency = Forms[namespace][dependency_id]["value"];
  let country = Countries.Countries[dependency];
  if (country && country.ISO_2Code) {
    let number = Forms.phoneUtil.parse(value, country.ISO_2Code);
    fields_validity[id] = Forms.phoneUtil.isValidNumberForRegion(number, country.ISO_2Code);
  } else {
    fields_validity[id] = Settings.formats.phonenumber.test(value);
  }
}
export default Forms;
